import React from "react";
import RenderChildrenWrapper from "../../common/RenderChildrenWrapper";
import SummaryCell from "./SummaryCell/SummaryCell";
const PolicyViolations = ({ checksCount, detectedCount, footerWrapper, }) => {
    return (React.createElement(SummaryCell, { label: "Issues found", value: detectedCount.toLocaleString(), subline: React.createElement(RenderChildrenWrapper, { wrapper: footerWrapper && ((children) => footerWrapper(children)) },
            React.createElement("span", null,
                checksCount.toLocaleString(),
                " evaluated policies")) }));
};
export default PolicyViolations;
//# sourceMappingURL=PolicyViolations.js.map